import { render, staticRenderFns } from "./UserAgreementCreate.vue?vue&type=template&id=1390af7e&scoped=true&"
import script from "./UserAgreementCreate.vue?vue&type=script&lang=ts&"
export * from "./UserAgreementCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390af7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
